export default "__VITE_PUBLIC_ASSET__f0aec0cf__"